/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import ClickableElement from '../../ClickableElement';

import styles from './index.styl';

const ActionButton = ({ onClick, children, style, ariaLabel = '' }) => (
  <div styleName="root" style={style}>
    <ClickableElement
      onClick={onClick}
      style={{ padding: 12 }}
      ariaLabel={ariaLabel}
    >
      {children}
    </ClickableElement>
  </div>
);

ActionButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  style: PropTypes.object,
  ariaLabel: PropTypes.string,
};

export default CSSModules(ActionButton, styles);



// WEBPACK FOOTER //
// ./src/components/common/ActionButton/index.jsx